import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconContacts",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], m = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.333.667a.5.5 0 0 1 .5-.5h7.334a.5.5 0 0 1 0 1H2.833a.5.5 0 0 1-.5-.5ZM1.48 1.98a.5.5 0 0 1 .353-.147h9.334a.5.5 0 0 1 .5.5v7.334a.5.5 0 0 1-.5.5H1.833a.5.5 0 0 1-.5-.5V2.333a.5.5 0 0 1 .147-.353Zm.853.853v6.334h1V9a1.833 1.833 0 0 1 1.834-1.833h2.666A1.833 1.833 0 0 1 9.667 9v.167h1V2.833H2.333Zm6.334 6.334V9a.833.833 0 0 0-.834-.833H5.167A.833.833 0 0 0 4.333 9v.167h4.334Zm-2.167-2a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667Zm0-2.667a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Zm-4.167 6.833a.5.5 0 0 1 .5-.5H10.3a.5.5 0 1 1 0 1H2.833a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), _ = [
  m
];
function h(e, u, i, f, p, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--contacts"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Contacts",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, _, 10, c);
}
const b = /* @__PURE__ */ s(l, [["render", h]]);
export {
  b as default
};
//# sourceMappingURL=contacts.js.map
